import Utils from '@/providers/Utils'
import Vue from "vue";
import pdfmake from "pdfmake";

export default {

    // -------- tool options ----------

    toolName: 'listGenerator',
    label: 'List Generator',
    logo: '',

    getDefaultData() {
        return {
            docTitle: 'Untitled',
            currentStep: 1,
            fontFace: 'sans',
            fontSize: 'large',

            listTitle: null,
            listDescription: null,

            listText: '',
            sampleSize: null,

            randomizedListItems: null,
        }
    },

    steps: [
        {id: 1, title: 'Header Information'},
        {id: 2, title: 'List Items'},
        {id: 3, title: 'Sample Size'}
    ],

    // define which download methods are supported - see ToolContainerPreviewToolbar::inject
    provide: function () {
        return {
            downloadDocFile: null,
            downloadPdfFile: null,
            exportToGoogleForms: null
        }
    },
}
